var _style, _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThailand = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.th_st0{fill:#CF0F15;}\n\t.th_st1{fill:#FFFFFF;}\n\t.th_st2{fill:#00247D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "th_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.2,
    className: "th_st1",
    width: 64,
    height: 29.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.6,
    className: "th_st2",
    width: 64,
    height: 16.8
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThailand, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Thailand.5b634578.svg";
export { ForwardRef as ReactComponent };